import { render, staticRenderFns } from "./MyCstmrList.vue?vue&type=template&id=000407e6&"
import script from "./MyCstmrList.vue?vue&type=script&lang=js&"
export * from "./MyCstmrList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports